import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {StaticImage} from "gatsby-plugin-image";
import {Link} from "gatsby";

function Testimonial(props) {
    return (
        <div className="rn-testimonial-area bg_color--3 ptb--120">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <div className="row align-items-center py-4 py-md-0">
                                <div className="col-lg-8">
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>Rudnik Sitarjevec ni več samo spomin na minule čase. Ohranjamo ga kot dragoceno naravno vrednoto državnega pomena in zanimivo tehnično dediščino. V prenovljeni obliki služi turistično-izobraževalnemu namenu in predstavlja izziv za razvoj inovativnih raziskovalnih postopkov.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>DR. Tea Kolar-Jurkovšek </span> - Znanstvena svetnica Geološkega zavoda Slovenije</h6>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </div>
                                <div className="col-lg-4 mt_md--40 mt_sm--40 d-none d-lg-block">
                                    <div className="testimonial-person ">
                                        <StaticImage
                                            src="../../assets/images/rudnik/tea-kolar-jurkovsek.jpg"
                                            alt="Dr. Tea Kolar - Jurkovšek - Znansvena svetnica Geološkega zavoda Slovenije"
                                            loading="lazy"
                                            placeholder="blurred"
                                            imgClassName="border-radius-full border-shadow-1"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Testimonial;